import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApplicationEmail } from '@lmc-app/shared/interface/application-email.interface';
import { Applicant } from '@lmc-app/shared/enum/applicant.enum';
import { DateUtil } from '@lmc-app/shared/utils/date.util';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
	selector: 'app-email-view-dialog',
	templateUrl: './email-view-dialog.component.html',
	standalone: true,
	styleUrls: ['./email-view-dialog.component.scss'],
	imports: [MatDialogModule, MatIconModule, MatButtonModule],
})
export class EmailViewDialogComponent implements OnInit {
	safeHtmlContent: SafeHtml;
	protected readonly Applicant = Applicant;
	protected readonly DateUtil = DateUtil;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { email: ApplicationEmail },
		private dialogRef: MatDialogRef<EmailViewDialogComponent>,
		private sanitizer: DomSanitizer
	) {}

	ngOnInit(): void {
		// Sanitize HTML content to prevent XSS attacks
		this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(
			this.data.email.content
		);
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onPrint(): void {
		const email = this.data.email;
		const printWindow = window.open('', '_blank');

		if (printWindow) {
			printWindow.document.write(`
        <html>
          <head>
            <title>Email - ${email.subject}</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                margin: 20px;
                line-height: 1.6;
                color: #333;
              }
              .email-header {
                border-bottom: 2px solid #ccc;
                padding-bottom: 16px;
                margin-bottom: 24px;
              }
              .email-header h3 {
                margin: 0 0 12px 0;
                color: #1976d2;
                font-size: 18px;
              }
              .email-meta {
                margin: 8px 0;
                color: #666;
              }
              .email-meta strong {
                color: #333;
                display: inline-block;
                min-width: 80px;
              }
              .email-content {
                line-height: 1.6;
                margin-top: 20px;
              }
              .email-content img {
                max-width: 100% !important;
                height: auto !important;
              }
              .email-content table {
                width: 100% !important;
                border-collapse: collapse;
              }
            </style>
          </head>
          <body>
            <div class="email-header">
              <h3>${email.subject}</h3>
              <div class="email-meta"><strong>From:</strong> ${
								email.senderName
							} &lt;${email.senderEmail}&gt;</div>
              <div class="email-meta"><strong>To:</strong> ${
								email.recipientName
							} &lt;${email.recipientEmail}&gt;</div>
              <div class="email-meta"><strong>Applicant:</strong> ${
								email.applicant
							}</div>
              <div class="email-meta"><strong>Date:</strong> ${this.DateUtil.formatDate(
								email.createdAt
							)}</div>
            </div>
            <div class="email-content">${email.content}</div>
          </body>
        </html>
      `);
			printWindow.document.close();
			printWindow.print();
		}
	}

	getApplicantDisplay(applicant: Applicant): string {
		switch (applicant) {
			case Applicant.MAIN:
				return 'Main Applicant';
			case Applicant.CO:
				return 'Co-Applicant';
			default:
				return applicant;
		}
	}
}
